import React from "react";
import { PageCover } from "../../../common/PageCover";

import "./AboutUsCover.css";

export const AboutUsCover = () => {
  return (
    <PageCover
      src="/img/about-us-cover.jpg"
      backText="ABOUT"
      frontText="US"
      description="Duo of inspiration and collaboration in the form of a friendly partnership created to freely bring bold ideas into life."
    />
  );
};
